import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import Badge from "components/Badge";

import {getDistinctRetailers} from "views/oms/OrderList/utils/getDistinctRetailers";

import {blue700, greyishBlue500} from "assets/jss/main";

MobileRetailerBadgeList.propTypes = {
    lineItems: PropTypes.arrayOf(PropTypes.shape({
        retailer: PropTypes.shape({
            name: PropTypes.string
        })
    })).isRequired
};

const RetailerBadge = ({retailerName}) => (
    <Badge
        color={'default'}
        size={'large'}
        rounded
        labelSize={14}
        isBold={false}
        labelColor={blue700}
        border
    >
        {retailerName.length > 24 ? retailerName.substring(0, 24) + '...' : retailerName}
    </Badge>
);

function MobileRetailerBadgeList({lineItems}) {
    const [showMore, setShowMore] = useState(false);

    const retailers = getDistinctRetailers(lineItems);
    const firstThreeRetailers = retailers.slice(0, 2);
    const otherRetailers = retailers.slice(2);

    return (
        <div style={{display: 'flex', gap: '4px', flexWrap: 'wrap', alignItems: 'center'}}>
            {firstThreeRetailers.map((retailer, index) => (
                <RetailerBadge
                    key={index}
                    retailerName={retailer.name}
                />
            ))}
            {!showMore && firstThreeRetailers.length < retailers.length && (
                <span
                    style={{
                        color: greyishBlue500,
                        fontSize: '14px',
                        fontWeight: 400,
                        cursor: 'pointer',
                        textDecoration: 'underline',
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        setShowMore(true);
                    }}
                >
                    <FormattedMessage id='retailer.product.list.stock.showMore' />
                </span>
            )}
            {showMore && otherRetailers.map((retailer, index) => (
                <RetailerBadge
                    key={index}
                    retailerName={retailer.name}
                />
            ))}
        </div>
    );
}

export default MobileRetailerBadgeList;
